import { actionTypes } from './actions';
import initialState from './initialState';
import { Map } from 'immutable';

export default function editedFormulaReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_EDITED_FORMULA_ID:
      return Map({ [action.payload]: true });
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
}
